import { render, staticRenderFns } from "./WPSS.vue?vue&type=template&id=30fbba7c&scoped=true"
import script from "./WPSS.vue?vue&type=script&lang=js"
export * from "./WPSS.vue?vue&type=script&lang=js"
import style0 from "./WPSS.vue?vue&type=style&index=0&id=30fbba7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fbba7c",
  null
  
)

export default component.exports